<template>
  <el-scrollbar
    ref="scrollBarRef"
    class="qd-table-v3"
    :custom-el="scrollerRef?.$el"
    :custom-extra-gap="headerHeight"
    :style="{
      '--row-total-width': totalWidth + 'px',
      '--vertical-bar-top': headerHeight + 2 + 'px',
    }"
  >
    <RecycleScroller
      ref="scrollerRef"
      :items="dataList"
      :item-size="itemSize"
      :style="{
        height: height + 'px',
        width: width + 'px',
      }"
      :key-field="keyField"
      class="qd-table-v3__table"
      @scroll="scrollBarRef?.handleScroll"
    >
      <template #before>
        <div
          class="qd-table-v3__header-row relative"
          :style="{
            width: totalWidth + 'px',
          }"
        >
          <div class="qd-table-v3__row-cell--fixed flex">
            <div
              v-for="(columnItem, columnIndex) in fixedLeftColumns"
              :key="columnIndex"
              :style="{
                width: columnItem.width + 'px',
              }"
              class="qd-table-v3__header-cell"
              :class="columnItem.headerClass"
            >
              <component
                :is="columnItem.headerCellRenderer"
                v-if="columnItem.headerCellRenderer"
              />
              <template v-else>
                {{ columnItem.title }}
              </template>
            </div>
          </div>
          <div
            v-for="(columnItem, columnIndex) in noFixedColumns"
            :key="columnIndex"
            :style="{
              width: columnItem.width + 'px',
            }"
            class="qd-table-v3__header-cell"
            :class="columnItem.headerClass"
          >
            <component
              :is="columnItem.headerCellRenderer"
              v-if="columnItem.headerCellRenderer"
            />
            <template v-else>
              {{ columnItem.title }}
            </template>
          </div>
        </div>
      </template>
      <template #default="{ item }">
        <div
          class="qd-table-v3__row relative"
          :class="rowClass(item)"
          :style="{
            height: itemSize + 'px',
            width: totalWidth + 'px',
          }"
        >
          <div class="qd-table-v3__row-cell--fixed flex">
            <div
              v-for="(columnItem, columnIndex) in fixedLeftColumns"
              :key="columnIndex"
              :style="{
                width: columnItem.width + 'px',
              }"
              class="qd-table-v3__row-cell"
              :class="columnItem.class"
            >
              <component
                :is="
                  columnItem.cellRenderer({
                    rowData: item,
                    rowIndex: columnIndex,
                  })
                "
              />
            </div>
          </div>
          <div
            v-for="(columnItem, columnIndex) in noFixedColumns"
            :key="columnIndex"
            :style="{
              width: columnItem.width + 'px',
            }"
            class="qd-table-v3__row-cell"
            :class="columnItem.class"
          >
            <component
              :is="
                columnItem.cellRenderer({
                  rowData: item,
                  rowIndex: columnIndex,
                })
              "
            />
          </div>
        </div>
      </template>
    </RecycleScroller>
  </el-scrollbar>
</template>
<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import { RecycleScroller } from 'vue-virtual-scroller'
defineOptions({
  name: 'ElTableV3',
})
const props = withDefaults(
  defineProps<{
    width: number
    itemSize: number
    columns: any[]
    dataList: any[]
    height: number
    keyField: string
    headerHeight: number
    rowClass: (rowData: any) => string
  }>(),
  {
    itemSize: 80,
    keyField: 'id',
    headerHeight: 60,
    rowClass: () => '',
  }
)
const scrollBarRef = ref()
const scrollerRef = ref()

const fixedLeftColumns = computed(() => {
  return props.columns.filter((e) => e.fixed === 'left')
})
const noFixedColumns = computed(() => {
  return props.columns.filter((e) => e.fixed !== 'left')
})

const totalWidth = computed(() => {
  return props.columns.reduce((acc, item) => acc + item.width, 0)
})

onMounted(() => {
  if (scrollBarRef.value && scrollerRef.value) {
    scrollBarRef.value.update()
  }
})
</script>
